/* Keuringsstickers 8x5 Studio (projecten/keuringsstickers-8x5-studio/thema/)
 *
 * Zelfde opzet als de ronde studio: een IIFE met een state en een teken()-
 * functie die alles opnieuw opbouwt. Geen build-stap, geen framework.
 *
 * De sticker wordt hier LIVE getekend (vrije kleuren, dus geen kant-en-klare
 * ondergronden): vlak + rand als vlakken, de vaste maanden/jaartallen/lijntjes
 * als tintbare overlay-PNG (gerenderd uit het bronbestand, echte fonts), de
 * klantteksten via canvas-tekst. Alle maten komen uit window.STUDIO8X5_GEO,
 * dat door upload_thema.py uit geometrie.json wordt gegenereerd. De druk is
 * leidend: deze preview spiegelt wat drukbestand.jsx straks bouwt.
 */
(function () {
  "use strict";

  var GEO = window.STUDIO8X5_GEO;
  var ASSETS = window.STUDIO8X5_ASSETS || {};
  if (!GEO) {
    return; // niets te doen zonder geometrie (bijv. verkeerde pagina)
  }

  // 10 logische px per mm: canvas 860x560 voor de pagina van 86x56 mm.
  var PX_PER_MM = 10;
  var CANVAS_B = Math.round(GEO.pagina_mm[0] * PX_PER_MM);
  var CANVAS_H = Math.round(GEO.pagina_mm[1] * PX_PER_MM);
  var PX_PER_PT = (25.4 / 72) * PX_PER_MM;

  // Fontstapels: de druk gebruikt de echte Arial-familie en Montserrat; de
  // preview pakt die waar ze er zijn en valt terug op de best gelijkende
  // Google-fonts (Archivo Black, Arimo) die de sectie meelaadt.
  var FONT_KOP = '"Arial Black", "Archivo Black", Arial, sans-serif';
  var FONT_VAK = 'Arial, Arimo, "Liberation Sans", sans-serif';
  var FONT_REGEL = 'Montserrat, Arial, sans-serif';

  // Zones voor krimpende tekst (mm): teksten mogen nooit de rand in lopen.
  // De kopteksten zijn vrij versleepbaar en schaalbaar, dus die krimpen pas
  // als ze echt breder zouden worden dan het kleurenvlak.
  var VAK_TEKST_MAX_MM = 63;
  var KOP_MAX_MM = 71;
  var REGEL_MAX_MM = 29.5;

  // Basislijn van koptekst 2 (standaard leeg; bedoeld voor tekst bij het
  // logo). Zelfde waarde in herteken.py en maak_drukbestanden.py.
  var KOP2_BASIS_Y_MM = 25.0;

  var LOGO_BREEDTE_MIN_MM = 8;
  var LOGO_BREEDTE_MAX_MM = 60;

  // Het kleurenvlak (waar logo en teksten wonen): tot aan de rand-rects.
  var VELD_MM = {
    x0: GEO.cutcontour.rect_mm[0],
    y0: GEO.cutcontour.rect_mm[1],
    x1: GEO.rand.rects_mm[1][0],
    y1: GEO.rand.rects_mm[0][1],
  };

  var canvas = document.getElementById("s85-canvas");
  if (!canvas) {
    return;
  }
  var ctx = null;

  var state = {
    vlakkleur: GEO.vlak.standaard_kleur,
    randkleur: GEO.rand.standaard_kleur,
    tekstkleurVlak: "#231f20",
    tekstkleurRand: "#ffffff",
    reeks: "27-31",
    vakjes: GEO.vakjes.map(function (v) { return v.standaard; }),
    koptekst: GEO.koptekst.standaard,
    regels: ["", ""],
    logoImg: null,
    logoUrl: null,
    logoBezigMetUploaden: false,
    // logopositie: midden van het logo in mm op de pagina
    logoPos: null,
    logoBreedteMm: 24,
    // versleepbare tekstgroepen: verschuiving in mm t.o.v. de vaste plek
    vakjesOffset: { x: 0, y: 0 },
    contactOffset: { x: 0, y: 0 },
    koptekstOffset: { x: 0, y: 0 },
    koptekstSchaal: 1,
    // tweede koptekst, standaard leeg (voor tekst bij het logo)
    koptekst2: "",
    koptekst2Offset: { x: 0, y: 0 },
    koptekst2Schaal: 1,
    bezigMetVerzenden: false,
    snapshotUrl: null,
  };

  var overlayCache = {}; // reeks -> Image
  var tintCache = {}; // sleutel -> canvas
  var iconen = {}; // naam -> Image
  var slepen = null;

  // --- Hulpjes -----------------------------------------------------------

  function mmx(v) { return v * PX_PER_MM; }

  function hexLuminantie(hex) {
    var h = hex.replace("#", "");
    var r = parseInt(h.slice(0, 2), 16) / 255;
    var g = parseInt(h.slice(2, 4), 16) / 255;
    var b = parseInt(h.slice(4, 6), 16) / 255;
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }

  function laadAfbeelding(url, klaar) {
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () { klaar(null, img); };
    img.onerror = function () { klaar("laden mislukt", null); };
    img.src = url;
  }

  function overlayVoorReeks(reeks, klaar) {
    if (overlayCache[reeks]) {
      klaar(null, overlayCache[reeks]);
      return;
    }
    laadAfbeelding(ASSETS.overlays[reeks], function (fout, img) {
      if (!fout) {
        overlayCache[reeks] = img;
      }
      klaar(fout, img);
    });
  }

  // Kleurt een witte PNG (overlay of icoon) naar een willekeurige kleur,
  // met behoud van alpha. Resultaat wordt gecachet per (naam, kleur).
  function getint(naam, img, kleur) {
    var sleutel = naam + "|" + kleur;
    if (tintCache[sleutel]) {
      return tintCache[sleutel];
    }
    var c = document.createElement("canvas");
    c.width = img.naturalWidth;
    c.height = img.naturalHeight;
    var cctx = c.getContext("2d");
    cctx.drawImage(img, 0, 0);
    cctx.globalCompositeOperation = "source-in";
    cctx.fillStyle = kleur;
    cctx.fillRect(0, 0, c.width, c.height);
    tintCache[sleutel] = c;
    return c;
  }

  function afgerondeRect(t, r_mm, radius_mm) {
    var x0 = mmx(r_mm[0]), y0 = mmx(r_mm[1]), x1 = mmx(r_mm[2]), y1 = mmx(r_mm[3]);
    var r = mmx(radius_mm);
    t.beginPath();
    t.moveTo(x0 + r, y0);
    t.lineTo(x1 - r, y0);
    t.arcTo(x1, y0, x1, y0 + r, r);
    t.lineTo(x1, y1 - r);
    t.arcTo(x1, y1, x1 - r, y1, r);
    t.lineTo(x0 + r, y1);
    t.arcTo(x0, y1, x0, y1 - r, r);
    t.lineTo(x0, y0 + r);
    t.arcTo(x0, y0, x0 + r, y0, r);
    t.closePath();
  }

  // Tekent tekst met tracking (letterspatiëring). ctx.letterSpacing waar de
  // browser het kan, anders teken voor teken.
  function tekstMetTracking(t, tekst, x, y, fontPx, fontStapel, gewicht, trackingEm, kleur) {
    t.fillStyle = kleur;
    t.font = gewicht + " " + fontPx + "px " + fontStapel;
    var trackingPx = (trackingEm || 0) * fontPx;
    if ("letterSpacing" in t) {
      t.letterSpacing = trackingPx + "px";
      t.fillText(tekst, x, y);
      t.letterSpacing = "0px";
      return;
    }
    var cx = x;
    for (var i = 0; i < tekst.length; i++) {
      t.fillText(tekst[i], cx, y);
      cx += t.measureText(tekst[i]).width + trackingPx;
    }
  }

  function meetBreedte(t, tekst, fontPx, fontStapel, gewicht, trackingEm) {
    t.font = gewicht + " " + fontPx + "px " + fontStapel;
    var basis = t.measureText(tekst).width;
    return basis + (trackingEm || 0) * fontPx * Math.max(0, tekst.length - 1);
  }

  // Laat een tekst krimpen tot hij binnen maxMm past; geeft de fontgrootte
  // in px terug. Nooit kleiner dan 55% van de startgrootte.
  function passendeGrootte(t, tekst, startPt, maxMm, fontStapel, gewicht, trackingEm) {
    var maxPx = mmx(maxMm);
    var grootte = startPt * PX_PER_PT;
    var minimum = grootte * 0.55;
    while (grootte > minimum && meetBreedte(t, tekst, grootte, fontStapel, gewicht, trackingEm) > maxPx) {
      grootte -= 0.5;
    }
    return grootte;
  }

  // Icoon-detectie voor de vrije regels: e-mail bij iets@iets.iets, telefoon
  // bij minstens 6 cijfers en verder alleen telefoontekens.
  function regelSoort(tekst) {
    var t = (tekst || "").trim();
    if (!t) {
      return null;
    }
    if (/\S+@\S+\.\S+/.test(t)) {
      return "email";
    }
    var cijfers = (t.match(/\d/g) || []).length;
    if (cijfers >= 6 && /^[\d\s()+\-\/.]+$/.test(t)) {
      return "telefoon";
    }
    return null;
  }

  // --- Tekenen -----------------------------------------------------------

  function tekenOp(t) {
    t.clearRect(0, 0, CANVAS_B, CANVAS_H);

    // webweergave: wit buiten de sticker, zoals de klant hem in handen krijgt
    t.fillStyle = "#ffffff";
    t.fillRect(0, 0, CANVAS_B, CANVAS_H);

    t.save();
    afgerondeRect(t, GEO.cutcontour.rect_mm, GEO.cutcontour.radius_mm);
    t.clip();

    // 1. vlak en rand
    t.fillStyle = state.vlakkleur;
    t.fillRect(0, 0, CANVAS_B, CANVAS_H);
    t.fillStyle = state.randkleur;
    GEO.rand.rects_mm.forEach(function (r) {
      t.fillRect(mmx(r[0]), mmx(r[1]), mmx(r[2] - r[0]), mmx(r[3] - r[1]));
    });

    // 2. overlay: maanden, jaartallen en frame-lijntjes in de rand-tekstkleur
    var overlay = overlayCache[state.reeks];
    if (overlay) {
      t.drawImage(getint("overlay-" + state.reeks, overlay, state.tekstkleurRand),
        0, 0, CANVAS_B, CANVAS_H);
    }

    // 3. logo, geclipt op het kleurenvlak; onder de teksten, zoals de druk
    if (state.logoImg) {
      t.save();
      t.beginPath();
      t.rect(mmx(VELD_MM.x0), mmx(VELD_MM.y0),
        mmx(VELD_MM.x1 - VELD_MM.x0), mmx(VELD_MM.y1 - VELD_MM.y0));
      t.clip();
      var lb = mmx(state.logoBreedteMm);
      var lh = lb * (state.logoImg.naturalHeight / state.logoImg.naturalWidth);
      t.drawImage(state.logoImg, mmx(state.logoPos.x) - lb / 2, mmx(state.logoPos.y) - lh / 2, lb, lh);
      t.restore();
    }

    // 4. vakjes + teksten (als groep verschuifbaar via state.vakjesOffset)
    var vakGroottePt = GEO.fonts.vakjes.grootte_pt;
    var vakTracking = GEO.fonts.vakjes.tracking_em || 0;
    var vOff = state.vakjesOffset;
    GEO.vakjes.forEach(function (vak, i) {
      var tekst = (state.vakjes[i] || "").trim();
      if (!tekst) {
        return;
      }
      afgerondeRect(t, [vak.rect_mm[0] + vOff.x, vak.rect_mm[1] + vOff.y,
        vak.rect_mm[2] + vOff.x, vak.rect_mm[3] + vOff.y], vak.radius_mm);
      t.strokeStyle = state.tekstkleurVlak;
      t.lineWidth = mmx(vak.lijndikte_mm);
      t.stroke();
      var grootte = passendeGrootte(t, tekst, vakGroottePt, VAK_TEKST_MAX_MM, FONT_VAK, "700", vakTracking);
      tekstMetTracking(t, tekst, mmx(vak.tekst_oorsprong_mm[0] + vOff.x),
        mmx(vak.tekst_oorsprong_mm[1] + vOff.y),
        grootte, FONT_VAK, "700", vakTracking, state.tekstkleurVlak);
    });

    // 5. de twee kopteksten, elk rechts uitgelijnd op hun eigen ankerpunt,
    // los versleepbaar en los schaalbaar
    kopConfigs().forEach(function (c) {
      var kop = (c.tekst || "").trim();
      if (!kop) {
        return;
      }
      var startPt = GEO.fonts.koptekst.grootte_pt * c.schaal;
      var kopGrootte = passendeGrootte(t, kop, startPt, KOP_MAX_MM, FONT_KOP, "900", 0);
      var kopBreed = meetBreedte(t, kop, kopGrootte, FONT_KOP, "900", 0);
      tekstMetTracking(t, kop, mmx(GEO.koptekst.bbox_mm[2] + c.offset.x) - kopBreed,
        mmx(c.basisY + c.offset.y),
        kopGrootte, FONT_KOP, "900", 0, state.tekstkleurVlak);
    });

    // 6. vrije regels met automatisch icoontje (samen de contactgroep,
    // verschuifbaar via state.contactOffset)
    var cOff = state.contactOffset;
    GEO.regels.forEach(function (regelGeo, i) {
      var tekst = (state.regels[i] || "").trim();
      if (!tekst) {
        return;
      }
      var soort = regelSoort(tekst);
      var tekstX = regelGeo.tekst_oorsprong_mm[0];
      if (soort && iconen[soort]) {
        // het icoon van de HERKENDE soort. Op zijn eigen regel staat het
        // exact op de natuurlijke plek (zoals de druk); alleen een gewisseld
        // icoon (bijv. e-mail op regel 1) wordt gecentreerd in de icoonzone
        // van deze regel.
        var eigen = ASSETS.icoonBboxen["icoon-" + soort];
        var eb = eigen[2] - eigen[0];
        var eh = eigen[3] - eigen[1];
        var cx, cy;
        if (soort === regelGeo.soort) {
          cx = (eigen[0] + eigen[2]) / 2 + cOff.x;
          cy = (eigen[1] + eigen[3]) / 2 + cOff.y;
        } else {
          var zone = regelGeo.icoon.bbox_mm;
          cx = (zone[0] + zone[2]) / 2 + cOff.x;
          cy = (zone[1] + zone[3]) / 2 + cOff.y;
        }
        t.drawImage(getint("icoon-" + soort, iconen[soort], state.tekstkleurVlak),
          mmx(cx - eb / 2), mmx(cy - eh / 2), mmx(eb), mmx(eh));
      } else {
        // geen icoontje: tekst begint netjes op de icoonpositie
        tekstX = regelGeo.icoon.bbox_mm[0];
      }
      var grootte = passendeGrootte(t, tekst, GEO.fonts.regels.grootte_pt, REGEL_MAX_MM, FONT_REGEL, "400", 0);
      tekstMetTracking(t, tekst, mmx(tekstX + cOff.x),
        mmx(regelGeo.tekst_oorsprong_mm[1] + cOff.y),
        grootte, FONT_REGEL, "400", 0, state.tekstkleurVlak);
    });

    t.restore();

    // dun lijntje om de stickerrand, anders zweeft een lichte sticker
    // onzichtbaar op het witte canvas
    afgerondeRect(t, GEO.cutcontour.rect_mm, GEO.cutcontour.radius_mm);
    t.strokeStyle = "rgba(0, 0, 0, 0.15)";
    t.lineWidth = 1;
    t.stroke();
  }

  function teken() {
    if (ctx) {
      // teksten kunnen net gewijzigd zijn en de groepen groter of kleiner
      // gemaakt hebben: altijd eerst herklemmen, dan pas tekenen
      klemGroepOffset("vakjes");
      klemGroepOffset("contact");
      klemGroepOffset("koptekst");
      klemGroepOffset("koptekst2");
      tekenOp(ctx);
    }
    bijwerkenContrastHint();
  }

  // --- Contrast-hint (zachtjes waarschuwen, nooit blokkeren) --------------

  function bijwerkenContrastHint() {
    var el = document.getElementById("s85-contrast-hint");
    if (!el) {
      return;
    }
    var meldingen = [];
    var vlakLum = hexLuminantie(state.vlakkleur);
    var randLum = hexLuminantie(state.randkleur);
    if (state.tekstkleurVlak === "#ffffff" && vlakLum > 0.6) {
      meldingen.push("Witte tekst op dit lichte vlak leest lastig; zwart leest hier beter.");
    }
    if (state.tekstkleurVlak === "#231f20" && vlakLum < 0.15) {
      meldingen.push("Zwarte tekst op dit donkere vlak leest lastig; wit leest hier beter.");
    }
    if (state.tekstkleurRand === "#ffffff" && randLum > 0.6) {
      meldingen.push("Witte maanden en jaartallen op deze lichte rand lezen lastig; zwart leest hier beter.");
    }
    if (state.tekstkleurRand === "#231f20" && randLum < 0.15) {
      meldingen.push("Zwarte maanden en jaartallen op deze donkere rand lezen lastig; wit leest hier beter.");
    }
    el.textContent = meldingen.join(" ");
    el.hidden = meldingen.length === 0;
  }

  // --- Logo --------------------------------------------------------------

  function standaardLogoPositie() {
    var bb = GEO.logo_voorbeeld_bbox_mm;
    if (bb) {
      return { x: (bb[0] + bb[2]) / 2, y: (bb[1] + bb[3]) / 2 };
    }
    return { x: (VELD_MM.x0 + VELD_MM.x1) / 2, y: (VELD_MM.y0 + VELD_MM.y1) / 2 };
  }

  function klemLogoPositie() {
    if (!state.logoPos) {
      return;
    }
    var marge = 2; // het midden blijft altijd ruim op het vlak
    state.logoPos.x = Math.min(Math.max(state.logoPos.x, VELD_MM.x0 + marge), VELD_MM.x1 - marge);
    state.logoPos.y = Math.min(Math.max(state.logoPos.y, VELD_MM.y0 + marge), VELD_MM.y1 - marge);
  }

  function logoRechthoekPx() {
    var lb = mmx(state.logoBreedteMm);
    var lh = state.logoImg ? lb * (state.logoImg.naturalHeight / state.logoImg.naturalWidth) : lb;
    return {
      x: mmx(state.logoPos.x) - lb / 2,
      y: mmx(state.logoPos.y) - lh / 2,
      b: lb,
      h: lh,
    };
  }

  function puntInLogo(punt) {
    if (!state.logoImg || !state.logoPos) {
      return false;
    }
    var r = logoRechthoekPx();
    return punt.x >= r.x && punt.x <= r.x + r.b && punt.y >= r.y && punt.y <= r.y + r.h;
  }

  // Positie stickervlak-relatief (0..1 binnen de CutContour), zodat de druk
  // hem zonder canvaskennis kan terugrekenen; schaal gewoon in mm.
  function logoPositieVoorProperty() {
    var cc = GEO.cutcontour.rect_mm;
    return {
      x: Math.round(((state.logoPos.x - cc[0]) / (cc[2] - cc[0])) * 10000) / 10000,
      y: Math.round(((state.logoPos.y - cc[1]) / (cc[3] - cc[1])) * 10000) / 10000,
    };
  }

  // --- Versleepbare tekstgroepen ------------------------------------------
  // Elke groep heeft een basis-rechthoek in mm (op de vaste plek, gemeten met
  // de echte tekstbreedtes); de offset schuift hem, de klem houdt hem binnen
  // het kleurenvlak.

  function vakjesBasisMm() {
    var bbox = null;
    GEO.vakjes.forEach(function (vak, i) {
      var tekst = (state.vakjes[i] || "").trim();
      if (!tekst || !ctx) {
        return;
      }
      var grootte = passendeGrootte(ctx, tekst, GEO.fonts.vakjes.grootte_pt,
        VAK_TEKST_MAX_MM, FONT_VAK, "700", GEO.fonts.vakjes.tracking_em || 0);
      var breedMm = meetBreedte(ctx, tekst, grootte, FONT_VAK, "700",
        GEO.fonts.vakjes.tracking_em || 0) / PX_PER_MM;
      var r = [vak.rect_mm[0], vak.rect_mm[1],
               Math.max(vak.rect_mm[2], vak.tekst_oorsprong_mm[0] + breedMm), vak.rect_mm[3]];
      bbox = bbox ? [Math.min(bbox[0], r[0]), Math.min(bbox[1], r[1]),
                     Math.max(bbox[2], r[2]), Math.max(bbox[3], r[3])] : r;
    });
    return bbox;
  }

  function contactBasisMm() {
    var bbox = null;
    GEO.regels.forEach(function (regelGeo, i) {
      var tekst = (state.regels[i] || "").trim();
      if (!tekst || !ctx) {
        return;
      }
      var grootte = passendeGrootte(ctx, tekst, GEO.fonts.regels.grootte_pt,
        REGEL_MAX_MM, FONT_REGEL, "400", 0);
      var breedMm = meetBreedte(ctx, tekst, grootte, FONT_REGEL, "400", 0) / PX_PER_MM;
      var zone = regelGeo.icoon.bbox_mm;
      var r = [zone[0], zone[1],
               regelGeo.tekst_oorsprong_mm[0] + breedMm, Math.max(zone[3], regelGeo.tekst_oorsprong_mm[1])];
      bbox = bbox ? [Math.min(bbox[0], r[0]), Math.min(bbox[1], r[1]),
                     Math.max(bbox[2], r[2]), Math.max(bbox[3], r[3])] : r;
    });
    return bbox;
  }

  // De twee kopteksten met hun eigen tekst, offset, schaal en basislijn.
  function kopConfigs() {
    return [
      { tekst: state.koptekst, offset: state.koptekstOffset,
        schaal: state.koptekstSchaal, basisY: GEO.koptekst.oorsprong_mm[1] },
      { tekst: state.koptekst2, offset: state.koptekst2Offset,
        schaal: state.koptekst2Schaal, basisY: KOP2_BASIS_Y_MM },
    ];
  }

  function koptekstBasisMm(index) {
    var c = kopConfigs()[index];
    var kop = (c.tekst || "").trim();
    if (!kop || !ctx) {
      return null;
    }
    var grootte = passendeGrootte(ctx, kop, GEO.fonts.koptekst.grootte_pt * c.schaal,
      KOP_MAX_MM, FONT_KOP, "900", 0);
    var breedMm = meetBreedte(ctx, kop, grootte, FONT_KOP, "900", 0) / PX_PER_MM;
    var hoogMm = (grootte / PX_PER_MM) * 1.0;
    var rechts = GEO.koptekst.bbox_mm[2];
    return [rechts - breedMm, c.basisY - hoogMm, rechts, c.basisY + hoogMm * 0.25];
  }

  var GROEPEN = {
    koptekst: { basis: function () { return koptekstBasisMm(0); },
                offset: function () { return state.koptekstOffset; } },
    koptekst2: { basis: function () { return koptekstBasisMm(1); },
                 offset: function () { return state.koptekst2Offset; } },
    contact: { basis: contactBasisMm, offset: function () { return state.contactOffset; } },
    vakjes: { basis: vakjesBasisMm, offset: function () { return state.vakjesOffset; } },
  };

  function klem(waarde, laag, hoog) {
    return Math.min(Math.max(waarde, Math.min(laag, hoog)), Math.max(laag, hoog));
  }

  function klemGroepOffset(naam) {
    var groep = GROEPEN[naam];
    var basis = groep.basis();
    if (!basis) {
      return;
    }
    var offset = groep.offset();
    offset.x = klem(offset.x, VELD_MM.x0 - basis[0], VELD_MM.x1 - basis[2]);
    offset.y = klem(offset.y, VELD_MM.y0 - basis[1], VELD_MM.y1 - basis[3]);
  }

  function puntInGroep(punt, naam) {
    var groep = GROEPEN[naam];
    var basis = groep.basis();
    if (!basis) {
      return false;
    }
    var offset = groep.offset();
    var marge = mmx(1.2); // iets ruimer pakken dan de strakke bbox
    var x0 = mmx(basis[0] + offset.x) - marge;
    var y0 = mmx(basis[1] + offset.y) - marge;
    var x1 = mmx(basis[2] + offset.x) + marge;
    var y1 = mmx(basis[3] + offset.y) + marge;
    return punt.x >= x0 && punt.x <= x1 && punt.y >= y0 && punt.y <= y1;
  }

  // Verschuiving stickervlak-relatief op de order, zelfde contract als het
  // logo: dx/dy als fractie van de CutContour-breedte/-hoogte.
  function groepOffsetVoorProperty(offset) {
    var cc = GEO.cutcontour.rect_mm;
    return {
      dx: Math.round((offset.x / (cc[2] - cc[0])) * 10000) / 10000,
      dy: Math.round((offset.y / (cc[3] - cc[1])) * 10000) / 10000,
    };
  }

  // --- Upload en status ---------------------------------------------------

  function uploadBestand(bestand, opSucces, opFout) {
    var fd = new FormData();
    fd.append("bestand", bestand, bestand.name || "snapshot.png");
    fetch(window.STUDIO_UPLOAD_URL, { method: "POST", body: fd })
      .then(function (resp) {
        return resp.json().then(function (data) {
          return { ok: resp.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          opFout((result.data && result.data.fout) || "Uploaden is mislukt, probeer het nog eens.");
          return;
        }
        opSucces(result.data.url);
      })
      .catch(function () {
        opFout("Uploaden is mislukt, probeer het nog eens.");
      });
  }

  function toonLogoStatus(tekst, isFout) {
    var el = document.getElementById("s85-logo-status");
    if (el) {
      el.textContent = tekst || "";
      el.classList.toggle("is-fout", Boolean(isFout));
    }
  }

  function toonFoutmelding(tekst) {
    var el = document.getElementById("s85-foutmelding");
    if (el) {
      el.textContent = tekst || "";
      el.hidden = !tekst;
    }
  }

  function bijwerkenToevoegenKnopStatus() {
    var knop = document.getElementById("s85-toevoegen");
    if (knop) {
      knop.disabled = state.logoBezigMetUploaden || state.bezigMetVerzenden;
    }
  }

  function kiesLogoBestand(bestand) {
    if (!bestand) {
      return;
    }
    if (["image/jpeg", "image/png", "image/webp"].indexOf(bestand.type) === -1) {
      toonLogoStatus("Alleen JPG, PNG of WebP.", true);
      return;
    }
    if (bestand.size > 8 * 1024 * 1024) {
      toonLogoStatus("Het bestand is groter dan 8 MB, maak het eerst wat kleiner.", true);
      return;
    }
    var lokaleUrl = URL.createObjectURL(bestand);
    var img = new Image();
    img.onload = function () {
      state.logoImg = img;
      if (!state.logoPos) {
        state.logoPos = standaardLogoPositie();
      }
      klemLogoPositie();
      state.logoBezigMetUploaden = true;
      state.logoUrl = null;
      bijwerkenToevoegenKnopStatus();
      toonLogoStatus("Logo uploaden...");
      teken();
      uploadBestand(bestand, function (url) {
        state.logoUrl = url;
        state.logoBezigMetUploaden = false;
        bijwerkenToevoegenKnopStatus();
        toonLogoStatus("Logo staat erop. Sleep hem op zijn plek.");
      }, function (fout) {
        state.logoBezigMetUploaden = false;
        bijwerkenToevoegenKnopStatus();
        toonLogoStatus(fout, true);
      });
    };
    img.onerror = function () {
      toonLogoStatus("Dit bestand kon niet gelezen worden.", true);
    };
    img.src = lokaleUrl;
  }

  // --- Winkelwagen --------------------------------------------------------

  function valideerVoorWinkelwagen() {
    if (state.logoBezigMetUploaden) {
      return "Je logo wordt nog geupload, wacht heel even.";
    }
    if (state.logoImg && !state.logoUrl) {
      return "Het uploaden van je logo is niet gelukt. Upload het opnieuw voor je bestelt.";
    }
    return null;
  }

  function reeksLabel(reeks) {
    var delen = reeks.split("-");
    return "20" + delen[0] + "-20" + delen[1];
  }

  function voegToeAanWinkelwagen() {
    var aantalEl = document.getElementById("s85-aantal");
    var variantId = aantalEl ? parseInt(aantalEl.value, 10) : 0;
    if (!variantId) {
      toonFoutmelding("Kies een aantal.");
      state.bezigMetVerzenden = false;
      bijwerkenToevoegenKnopStatus();
      return;
    }
    var fd = new FormData();
    fd.append("id", String(variantId));
    fd.append("quantity", "1");
    fd.append("properties[Vlakkleur]", state.vlakkleur);
    fd.append("properties[Randkleur]", state.randkleur);
    fd.append("properties[Tekstkleur vlak]", state.tekstkleurVlak === "#ffffff" ? "wit" : "zwart");
    fd.append("properties[Tekstkleur rand]", state.tekstkleurRand === "#ffffff" ? "wit" : "zwart");
    fd.append("properties[Jaarreeks]", reeksLabel(state.reeks));
    fd.append("properties[Koptekst 1]", (state.koptekst || "").trim());
    fd.append("properties[Koptekst 2]", (state.koptekst2 || "").trim());
    fd.append("properties[Vakje 1]", (state.vakjes[0] || "").trim());
    fd.append("properties[Vakje 2]", (state.vakjes[1] || "").trim());
    fd.append("properties[Vakje 3]", (state.vakjes[2] || "").trim());
    fd.append("properties[Regel 1]", (state.regels[0] || "").trim());
    fd.append("properties[Regel 2]", (state.regels[1] || "").trim());
    fd.append("properties[_LogoURL]", state.logoUrl || "");
    fd.append("properties[_LogoPositie]", state.logoUrl && state.logoPos ? JSON.stringify(logoPositieVoorProperty()) : "");
    fd.append("properties[_LogoSchaal]", state.logoUrl ? String(state.logoBreedteMm) : "");
    fd.append("properties[_VakjesPositie]", JSON.stringify(groepOffsetVoorProperty(state.vakjesOffset)));
    fd.append("properties[_ContactPositie]", JSON.stringify(groepOffsetVoorProperty(state.contactOffset)));
    fd.append("properties[_KoptekstPositie]", JSON.stringify(groepOffsetVoorProperty(state.koptekstOffset)));
    fd.append("properties[_Koptekst2Positie]", JSON.stringify(groepOffsetVoorProperty(state.koptekst2Offset)));
    fd.append("properties[_KoptekstSchaal]", String(state.koptekstSchaal));
    fd.append("properties[_Koptekst2Schaal]", String(state.koptekst2Schaal));
    fd.append("properties[_SnapshotURL]", state.snapshotUrl || "");

    fetch("/cart/add.js", { method: "POST", body: fd })
      .then(function (resp) {
        return resp.json().then(function (data) {
          return { ok: resp.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          toonFoutmelding((result.data && result.data.description) || "Toevoegen aan de winkelwagen is mislukt.");
          state.bezigMetVerzenden = false;
          bijwerkenToevoegenKnopStatus();
          return;
        }
        window.location = "/cart";
      })
      .catch(function () {
        toonFoutmelding("Toevoegen aan de winkelwagen is mislukt.");
        state.bezigMetVerzenden = false;
        bijwerkenToevoegenKnopStatus();
      });
  }

  // Snapshot op een los canvas in vaste logische maat, zodat Retina of
  // telefoon geen afwijkend formaat oplevert.
  function maakSnapshotBlob(callback) {
    var c = document.createElement("canvas");
    c.width = CANVAS_B;
    c.height = CANVAS_H;
    tekenOp(c.getContext("2d"));
    c.toBlob(callback, "image/png");
  }

  // --- Init ---------------------------------------------------------------

  function initCanvasHiDPI() {
    var dpr = window.devicePixelRatio || 1;
    canvas.width = CANVAS_B * dpr;
    canvas.height = CANVAS_H * dpr;
    ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);
  }

  function pointerNaarCanvas(evt) {
    var rect = canvas.getBoundingClientRect();
    return {
      x: ((evt.clientX - rect.left) * CANVAS_B) / rect.width,
      y: ((evt.clientY - rect.top) * CANVAS_H) / rect.height,
    };
  }

  function koppelTekstveld(id, zetter) {
    var el = document.getElementById(id);
    if (el) {
      el.addEventListener("input", function () {
        zetter(el.value);
        teken();
      });
    }
  }

  function koppelKleurgroep(groepId, kiezerId, zetter) {
    var groep = document.getElementById(groepId);
    var kiezer = document.getElementById(kiezerId);
    if (groep) {
      groep.addEventListener("click", function (evt) {
        var knop = evt.target.closest("[data-kleur]");
        if (!knop) {
          return;
        }
        zetter(knop.getAttribute("data-kleur"));
        groep.querySelectorAll("[data-kleur]").forEach(function (b) {
          b.classList.toggle("is-actief", b === knop);
        });
        if (kiezer) {
          kiezer.value = knop.getAttribute("data-kleur");
        }
        teken();
      });
    }
    if (kiezer) {
      kiezer.addEventListener("input", function () {
        zetter(kiezer.value);
        if (groep) {
          groep.querySelectorAll("[data-kleur]").forEach(function (b) {
            b.classList.remove("is-actief");
          });
        }
        teken();
      });
    }
  }

  function koppelSchakelaar(groepId, zetter) {
    var groep = document.getElementById(groepId);
    if (!groep) {
      return;
    }
    groep.addEventListener("click", function (evt) {
      var knop = evt.target.closest("[data-waarde]");
      if (!knop) {
        return;
      }
      zetter(knop.getAttribute("data-waarde"));
      groep.querySelectorAll("[data-waarde]").forEach(function (b) {
        b.classList.toggle("is-actief", b === knop);
      });
      teken();
    });
  }

  function euroTekst(cent) {
    return (cent / 100).toLocaleString("nl-NL", { style: "currency", currency: "EUR" });
  }

  // De staffelvarianten heten "100 stuks" t/m "2000 stuks"; de keuzelijst
  // wordt hieruit gevuld zodat het harnas (zonder Shopify) dezelfde route
  // draait als de echte productpagina.
  function vulAantalKeuzelijst() {
    var aantalEl = document.getElementById("s85-aantal");
    var varianten = window.STUDIO8X5_VARIANTEN;
    if (!aantalEl || !varianten || !varianten.length) {
      return;
    }
    varianten.forEach(function (variant) {
      var optie = document.createElement("option");
      optie.value = String(variant.id);
      optie.dataset.prijs = String(variant.prijs);
      optie.dataset.aantal = String(parseInt(variant.titel, 10) || 100);
      optie.textContent = variant.titel + " - " + euroTekst(variant.prijs);
      aantalEl.appendChild(optie);
    });
  }

  function bijwerkenPrijs() {
    var aantalEl = document.getElementById("s85-aantal");
    var prijsEl = document.getElementById("s85-prijs");
    if (!aantalEl || !prijsEl || !aantalEl.options.length) {
      return;
    }
    var optie = aantalEl.options[aantalEl.selectedIndex];
    var aantal = parseInt(optie.dataset.aantal, 10) || 100;
    var cent = parseInt(optie.dataset.prijs, 10) || 0;
    prijsEl.textContent = aantal + " stickers voor " + euroTekst(cent) +
      " (" + euroTekst(cent / aantal) + " per sticker)";
  }

  function initGebeurtenissen() {
    koppelKleurgroep("s85-vlak-presets", "s85-vlak-kiezer", function (k) { state.vlakkleur = k; });
    koppelKleurgroep("s85-rand-presets", "s85-rand-kiezer", function (k) { state.randkleur = k; });
    koppelSchakelaar("s85-tekstkleur-vlak", function (w) {
      state.tekstkleurVlak = w === "wit" ? "#ffffff" : "#231f20";
    });
    koppelSchakelaar("s85-tekstkleur-rand", function (w) {
      state.tekstkleurRand = w === "wit" ? "#ffffff" : "#231f20";
    });
    koppelSchakelaar("s85-reeksen", function (reeks) {
      state.reeks = reeks;
      overlayVoorReeks(reeks, function () { teken(); });
    });

    koppelTekstveld("s85-koptekst", function (v) { state.koptekst = v; });
    koppelTekstveld("s85-koptekst-2", function (v) { state.koptekst2 = v; });
    [["s85-koptekst-schaal", function (f) { state.koptekstSchaal = f; }],
     ["s85-koptekst2-schaal", function (f) { state.koptekst2Schaal = f; }]]
      .forEach(function (paar) {
        var el = document.getElementById(paar[0]);
        if (el) {
          el.addEventListener("input", function () {
            paar[1](Number(el.value) / 100);
            teken();
          });
        }
      });
    koppelTekstveld("s85-vakje-1", function (v) { state.vakjes[0] = v; });
    koppelTekstveld("s85-vakje-2", function (v) { state.vakjes[1] = v; });
    koppelTekstveld("s85-vakje-3", function (v) { state.vakjes[2] = v; });
    koppelTekstveld("s85-regel-1", function (v) { state.regels[0] = v; });
    koppelTekstveld("s85-regel-2", function (v) { state.regels[1] = v; });

    var schaal = document.getElementById("s85-logo-schaal");
    if (schaal) {
      schaal.addEventListener("input", function () {
        state.logoBreedteMm = LOGO_BREEDTE_MIN_MM +
          ((LOGO_BREEDTE_MAX_MM - LOGO_BREEDTE_MIN_MM) * Number(schaal.value)) / 100;
        klemLogoPositie();
        teken();
      });
    }

    var dropzone = document.getElementById("s85-dropzone");
    var logoInput = document.getElementById("s85-logo-input");
    if (logoInput) {
      logoInput.addEventListener("change", function () {
        kiesLogoBestand(logoInput.files && logoInput.files[0]);
      });
    }
    if (dropzone) {
      ["dragover", "dragenter"].forEach(function (soort) {
        dropzone.addEventListener(soort, function (evt) {
          evt.preventDefault();
          dropzone.classList.add("is-sleep");
        });
      });
      ["dragleave", "drop"].forEach(function (soort) {
        dropzone.addEventListener(soort, function (evt) {
          evt.preventDefault();
          dropzone.classList.remove("is-sleep");
        });
      });
      dropzone.addEventListener("drop", function (evt) {
        kiesLogoBestand(evt.dataTransfer && evt.dataTransfer.files && evt.dataTransfer.files[0]);
      });
    }

    canvas.addEventListener("pointerdown", function (evt) {
      var punt = pointerNaarCanvas(evt);
      // kleinste groepen eerst, dan het logo: zo blijft alles pakbaar als
      // groepen en logo elkaar overlappen
      var namen = ["koptekst2", "koptekst", "contact", "vakjes"];
      for (var i = 0; i < namen.length; i++) {
        if (puntInGroep(punt, namen[i])) {
          var offset = GROEPEN[namen[i]].offset();
          slepen = {
            doel: namen[i],
            gripX: punt.x / PX_PER_MM - offset.x,
            gripY: punt.y / PX_PER_MM - offset.y,
          };
          canvas.classList.add("is-slepen");
          canvas.setPointerCapture(evt.pointerId);
          return;
        }
      }
      if (puntInLogo(punt)) {
        var r = logoRechthoekPx();
        slepen = { doel: "logo", dx: punt.x - (r.x + r.b / 2), dy: punt.y - (r.y + r.h / 2) };
        canvas.classList.add("is-slepen");
        canvas.setPointerCapture(evt.pointerId);
      }
    });
    canvas.addEventListener("pointermove", function (evt) {
      if (!slepen) {
        return;
      }
      var punt = pointerNaarCanvas(evt);
      if (slepen.doel === "logo") {
        state.logoPos = {
          x: (punt.x - slepen.dx) / PX_PER_MM,
          y: (punt.y - slepen.dy) / PX_PER_MM,
        };
        klemLogoPositie();
      } else {
        var offset = GROEPEN[slepen.doel].offset();
        offset.x = punt.x / PX_PER_MM - slepen.gripX;
        offset.y = punt.y / PX_PER_MM - slepen.gripY;
        klemGroepOffset(slepen.doel);
      }
      teken();
    });
    ["pointerup", "pointercancel"].forEach(function (soort) {
      canvas.addEventListener(soort, function () {
        slepen = null;
        canvas.classList.remove("is-slepen");
      });
    });

    var aantalEl = document.getElementById("s85-aantal");
    if (aantalEl) {
      aantalEl.addEventListener("change", bijwerkenPrijs);
      aantalEl.addEventListener("input", bijwerkenPrijs);
    }

    var toevoegenKnop = document.getElementById("s85-toevoegen");
    if (toevoegenKnop) {
      toevoegenKnop.addEventListener("click", function () {
        var fout = valideerVoorWinkelwagen();
        if (fout) {
          toonFoutmelding(fout);
          return;
        }
        toonFoutmelding(null);
        state.bezigMetVerzenden = true;
        bijwerkenToevoegenKnopStatus();
        maakSnapshotBlob(function (blob) {
          if (!blob) {
            toonFoutmelding("Voorbeeld maken is mislukt, probeer het nog eens.");
            state.bezigMetVerzenden = false;
            bijwerkenToevoegenKnopStatus();
            return;
          }
          uploadBestand(blob, function (snapshotUrl) {
            state.snapshotUrl = snapshotUrl;
            voegToeAanWinkelwagen();
          }, function (foutTekst) {
            toonFoutmelding("Voorbeeld uploaden is mislukt: " + foutTekst);
            state.bezigMetVerzenden = false;
            bijwerkenToevoegenKnopStatus();
          });
        });
      });
    }
  }

  function init() {
    initCanvasHiDPI();
    vulAantalKeuzelijst();
    initGebeurtenissen();
    bijwerkenPrijs();

    // standaardteksten in de invoervelden zetten
    var kopEl = document.getElementById("s85-koptekst");
    if (kopEl) {
      kopEl.value = state.koptekst;
    }
    state.vakjes.forEach(function (tekst, i) {
      var el = document.getElementById("s85-vakje-" + (i + 1));
      if (el) {
        el.value = tekst;
      }
    });

    overlayVoorReeks(state.reeks, function (fout) {
      if (fout) {
        toonFoutmelding("Het voorbeeld kon niet geladen worden. Herlaad de pagina en probeer het nog eens.");
      }
      teken();
    });
    ["telefoon", "email"].forEach(function (naam) {
      laadAfbeelding(ASSETS.iconen[naam], function (fout, img) {
        if (!fout) {
          iconen[naam] = img;
          teken();
        }
      });
    });
    // opnieuw tekenen zodra de webfonts binnen zijn
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { teken(); });
    }
  }

  // Testhaakje voor Playwright: echte state en teken-functie.
  window.__studio8x5 = {
    state: state,
    teken: teken,
    tekenOp: tekenOp,
    GEO: GEO,
    regelSoort: regelSoort,
    logoPositieVoorProperty: logoPositieVoorProperty,
    groepOffsetVoorProperty: groepOffsetVoorProperty,
    klemGroepOffset: klemGroepOffset,
    puntInGroep: puntInGroep,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
